import { render, staticRenderFns } from "./SetAdminFeeDialog.vue?vue&type=template&id=081fb8da&scoped=true&lang=pug&"
import script from "./SetAdminFeeDialog.vue?vue&type=script&lang=js&"
export * from "./SetAdminFeeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081fb8da",
  null
  
)

export default component.exports